<template>
  <div class="container mt-3">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-12 col-lg-12 col-md-12">
        <div class="card z-index-0">
          <div class="card-body">
            <form role="form">
              <div class="row">
                <div class="col-6">
                  <soft-input id="fotoProveedor" type="text" placeholder="Foto proveedor" aria-label="Name" />
                </div>
                <div class="col-6">
                  <soft-input id="tipoDocumento" type="text" placeholder="Tipo de documento" aria-label="Name" />
                </div>
                <div class="col-6">
                  <soft-input id="nombreComercial" type="text" placeholder="Nombre comercial" aria-label="Name" />
                </div>
                <div class="col-6">
                  <soft-input id="razonSocial" type="text" placeholder="Razon social" aria-label="Name" />
                </div>
                <div class="col-6">
                  <soft-input id="regimenTributario" type="text" placeholder="Regimen Tributario" aria-label="Email" />
                </div>
                <div class="col-6">
                  <soft-input id="domicilio" type="text" placeholder="Domicilio" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="rutProveedor" type="text" placeholder="Rut proveedor" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="certificacionBancaria" type="text" placeholder="Certificacion Bancaria" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="tipoPago" type="text" placeholder="Tipo de pago" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="observacionGeneral" type="text" placeholder="Observacion general" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="colorProveedor" type="text" placeholder="Color de proveedor" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="contratista" type="text" placeholder="Contratista" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="primerNombre" type="text" placeholder="Primer nombre" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="segundoNombre" type="text" placeholder="Segundo nombre" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="primerNombre" type="text" placeholder="Primer nombre" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="primerApellido" type="text" placeholder="Primer apellido" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="segundoApellido" type="text" placeholder="Segundo apellidop" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="correoElectronico" type="text" placeholder="Correo electronico" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="telefono" type="text" placeholder="Telefono" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="celular" type="text" placeholder="Celular" aria-label="Password" />
                </div>
                <div class="col-6">
                  <soft-input id="direccion" type="text" placeholder="Direccion" aria-label="Password" />
                </div>
              </div>
              <soft-checkbox id="flexCheckDefault" name="flexCheckDefault" class="font-weight-light" checked>
                Acepto los
                <a href="javascript:;" class="text-dark font-weight-bolder">Términos y Condiciones</a>
              </soft-checkbox>

              <div class="text-center">
                <soft-button color="dark" full-width variant="gradient" class="my-4 mb-2">Registrarse</soft-button>
              </div>
              <p class="text-sm mt-3 mb-0">
                ¿Ya tiene una cuenta?
                <router-link :to="{ name: 'SignIn' }" class="text-dark font-weight-bolder">
                  Iniciar sesión
                </router-link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SoftInput from "@/components/SoftInput.vue";
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import SoftButton from "@/components/SoftButton.vue";

import { mapMutations } from "vuex";

export default {
  name: "SignupBasic",
  components: {
    SoftInput,
    SoftCheckbox,
    SoftButton,
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  methods: {
    ...mapMutations('appTemplate', ["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>
